module.exports = __webpack_public_path__ + "img/footer-qrcode.15e8e784.png";